import React from 'react';

const ProductCardSkeleton = () => (
  <div className="rounded-2xl bg-white ring-1 ring-slate-200/70 overflow-hidden animate-pulse">
    <div className="aspect-square bg-gradient-to-br from-slate-200 via-slate-100 to-slate-200" />
    <div className="p-3 space-y-2">
      <div className="h-2 w-16 bg-slate-200 rounded" />
      <div className="h-4 w-3/4 bg-slate-200 rounded" />
      <div className="h-3 w-1/2 bg-slate-200 rounded" />
      <div className="flex items-end justify-between pt-2">
        <div className="h-6 w-16 bg-slate-200 rounded" />
        <div className="flex gap-1">
          <div className="w-4 h-4 rounded-full bg-slate-200" />
          <div className="w-4 h-4 rounded-full bg-slate-200" />
        </div>
      </div>
    </div>
  </div>
);

export default ProductCardSkeleton;
